import { render, staticRenderFns } from "./LgFinderPageModulo.vue?vue&type=template&id=77baf692"
import script from "./LgFinderPageModulo.vue?vue&type=script&lang=js"
export * from "./LgFinderPageModulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports